"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeFirestoreHomeAddress = void 0;
var firestore_1 = require("firebase/firestore");
var firebase_1 = require("./firebase");
var extractFullAddressString = function (value) {
    if (!value)
        return undefined;
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "number") {
        return value.toString();
    }
    if (typeof value === "object") {
        var candidate = value;
        return ((typeof candidate.full_address === "string"
            ? candidate.full_address
            : undefined) ||
            (typeof candidate.fullAddress === "string"
                ? candidate.fullAddress
                : undefined) ||
            (typeof candidate.address === "string" ? candidate.address : undefined) ||
            (typeof candidate.value === "string" ? candidate.value : undefined));
    }
    return undefined;
};
/**
 * Ensures the `home_address.full_address` field in Firestore is stored as a string.
 * Previous versions of the app could accidentally persist the entire address object
 * at this path, which breaks backend validation on login.
 */
var normalizeFirestoreHomeAddress = function (firebaseUid) { return __awaiter(void 0, void 0, void 0, function () {
    var userRef, snapshot, data, homeAddress, fullAddressValue, normalizedFullAddress, _a, _fullAddress, rest, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                userRef = (0, firestore_1.doc)(firebase_1.firestore, "users", firebaseUid);
                return [4 /*yield*/, (0, firestore_1.getDoc)(userRef)];
            case 1:
                snapshot = _b.sent();
                if (!snapshot.exists()) {
                    return [2 /*return*/];
                }
                data = snapshot.data();
                homeAddress = data === null || data === void 0 ? void 0 : data.home_address;
                if (!homeAddress || typeof homeAddress !== "object") {
                    return [2 /*return*/];
                }
                fullAddressValue = homeAddress
                    .full_address;
                if (typeof fullAddressValue === "string") {
                    return [2 /*return*/]; // Already in the correct shape.
                }
                normalizedFullAddress = extractFullAddressString(fullAddressValue);
                if (!normalizedFullAddress) {
                    return [2 /*return*/];
                }
                _a = homeAddress, _fullAddress = _a.full_address, rest = __rest(_a, ["full_address"]);
                return [4 /*yield*/, (0, firestore_1.setDoc)(userRef, {
                        home_address: __assign(__assign({}, rest), { full_address: normalizedFullAddress }),
                    }, { merge: true })];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _b.sent();
                console.warn("Unable to normalize Firestore home address:", error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.normalizeFirestoreHomeAddress = normalizeFirestoreHomeAddress;
